import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
// Constants
import { primaryColor, primaryColorHover } from "../config/constants";

const NavigationLink = styled(Link)`
  margin: ${({ margin }) => margin && margin};
  padding: 0 15px;
  height: 38px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #fff;
  border-radius: 5px;
  background: ${primaryColor};
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
const NavigationBtn = styled.button`
  margin: ${({ margin }) => margin && margin};
  padding: 0 15px;
  height: 38px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #fff;
  border-radius: 5px;
  background: ${primaryColor};
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
const NavImg = styled.img`
  margin-right: 10px;
  width: 20px;
  height: 20px;
`;
const NavName = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #fff;
`;

const ButtonWithIcon = ({ icon, name, path, onClick, margin }) => {
  return path ? (
    <NavigationLink to={path} margin={margin}>
      <NavImg src={icon} alt="ico-link" />
      <NavName>{name}</NavName>
    </NavigationLink>
  ) : (
    <NavigationBtn onClick={onClick} margin={margin}>
      <NavImg src={icon} alt="ico-link" />
      <NavName>{name}</NavName>
    </NavigationBtn>
  );
};

export default ButtonWithIcon;
